<script lang="ts">
    import PageHeadingSection from "../ui/PageHeadingSection.svelte";
</script>

<svelte:head>
	<title>Czynności notarialne - Wrocław, Krzyki, Księże Małe</title>
	<meta name="description" content="Informacje o czynnosciach notarialnych" />
</svelte:head>

<PageHeadingSection 
	title="Czynności notarialne - Wrocław, Krzyki, Księże Małe"
	imageUrl="/czynnosci-notarialne.jpg"
/>

<div class="section">
	<div class="container">
		<span class="h2 heading">Czynnosci notarialne</span>

		<p class="paragraph">
			Notariusz jest powołany do dokonywania czynności notarialnych, którym strony są obowiązane lub pragną nadać formę notarialną (czynności notarialnych). Czynności notarialne, które dokonane zostaną przez notariusza zgodnie z prawem, mają charakter dokumentu urzędowego.
		</p>

		<p class="paragraph">
			Czynności notarialnych dokonuje się w języku polskim. Jeżeli strona czynności notarialnej nie posługuje się językiem polskim, czynność taka musi się odbyć przy udziale tłumacza przysięgłego.
		</p>

		<p class="paragraph separated-block">
			Notariusz dokonuje czynności w siedzibie prowadzonej kancelarii notarialnej. Czynności notarialne mogą zostać dokonane także w innym miejscu, jeżeli przemawia za tym charakter czynności bądź szczególne okoliczności.
		</p>

		<p class="paragraph">
			Zgodnie z art. 79 
			<a href="https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU19910220091" class="link" target="_blank">
				ustawy z dnia 14 lutego 1991 r. Prawo o notariacie
			</a> 
			Notariusz dokonuje następujących czynności:
		</p>

		<ul>
			<li>sporządza akty notarialne,</li>
			<li>sporządza akty poświadczenia dziedziczenia,</li>
			<li>podejmuje czynności dotyczące europejskiego poświadczenia spadkowego,</li>
			<li>podejmuje czynności związane z zarządem sukcesyjnym przedsiębiorstwem osoby fizycznej i z tymczasowym przedstawicielem w zakresie udziału małżonka przedsiębiorcy w przedsiębiorstwie, na zasadach określonych w ustawie z dnia 5 lipca 2018 r. o zarządzie sukcesyjnym przedsiębiorstwem osoby fizycznej i innych ułatwieniach związanych z sukcesją przedsiębiorstw,</li><li>sporządza poświadczenia,</li><li>spisuje protokoły,</li><li>sporządza protesty weksli i czeków,</li><li>przyjmuje na przechowanie pieniądze, papiery wartościowe, dokumenty, dane na informatycznym nośniku danych, o którym mowa w przepisach o informatyzacji działalności podmiotów realizujących zadania publiczne,</li><li>prowadzi rejestry akcjonariuszy prostych spółek akcyjnych oraz podejmuje związane z tym czynności,</li><li>sporządza wypisy, odpisy i wyciągi dokumentów,</li><li>sporządza, na żądanie stron, projekty aktów, oświadczeń i innych dokumentów,</li><li>składa wnioski o wpis w księdze wieczystej wraz z dokumentami stanowiącymi podstawę wpisu w księdze wieczystej,</li><li>sporządza inne czynności wynikające z odrębnych przepisów.</li>
		</ul>

		<p class="paragraph">
			Przed dokonaniem czynności notarialnej niezbędny jest kontakt z notariuszem w celu weryfikacji niezbędnych dokumentów, uzgodnienia treści oraz formy zamierzonej czynności notarialnej, a także określenia kosztów czynności notarialnej. Warto mieć na względzie, że im więcej okoliczności faktycznych i prawnych zostanie uzgodnionych wcześniej, tym sprawniej przebiegnie spotkanie u notariusza przeznaczone na dokonanie czynności notarialnej.
		</p>

		<div class="text-center">
			<a href="/dokumenty" class="btn">
				Dokumenty
			</a>
		</div>
	</div>
</div>